import PropTypes from 'prop-types';

export const Breakpoints = {
    xxsmall: 0,
    xsmall: 375,
    small: 768,
    medium: 1024,
    large: 1280,
    xlarge: 1440,
    xxlarge: 1520,
};

export const GridPropTypes = {
    breakpointsOfType: (type) =>
        PropTypes.shape({
            xxsmall: type,
            xsmall: type,
            small: type,
            medium: type,
            large: type,
            xlarge: type,
            xxlarge: type,
        }),
};

export const GridSize = 4;

export const MaxWidth = 1280;

export const NumColumns = 24;

// Heights are based on 4:3 aspect ratio resolutions
// Some breakpoints weren't standard, so calculations were made at https://calculateaspectratio.com/
const ViewportHeights = {
    [Breakpoints.xxsmall]: 281,
    [Breakpoints.xsmall]: 281,
    [Breakpoints.small]: 576,
    [Breakpoints.medium]: 768,
    [Breakpoints.large]: 960,
    [Breakpoints.xlarge]: 1080,
    [Breakpoints.xxlarge]: 1140,
};

export const ScreenResolutions = (breakpoint) => {
    return {
        height: ViewportHeights[breakpoint],
        width: breakpoint,
    };
};

export const DeviceResolutions = {
    IPHONE_X: {
        width: 375,
        height: 812,
    },
};
